import { CollectorPage, Collectors } from '.';

export default {
  path: 'collectors',
  childRoutes: [
    { path: ':tokenId', component: CollectorPage, isIndex: false },
    { path: '', component: Collectors, isIndex: false }]
};
